module.exports = __webpack_public_path__ + "media/barcelona musica/hall_balcony-37c3df36.jpg";